import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

const initialPODData = {
  //pod information
  PodCode: "",
  PodName: "",
  FacilityID: 0,
  SharedPod: 0,
  IsAllowedIndefiniteKioskAccess: 0,
  MessageAcess: 0,
  PhotoAccess: 0,
  FormReqAccess: 0,
  LawLibraryAccess: 0,
  CommissaryAccess: 0,
  DocumentsAccess: 0,
  PostalMailAccess: 0,
  DisplayCurrentDate: 0,
  ActiveStatus: 1,
  CreatedBy: 1,
};

const initiallogHistoryData = {
  InmateResidentId: "",
  FacilityID: 0,
  FirstName: "",
  FirstNameID: "",
  LastName: "",
  LastNameID: "",
  PodID: 0,
  KiosksCode: "",
  KiosksID: 0,
  GenderID: 0,
  FromDate: "",
  ToDate: "",
  ActiveStatus: 1,
  PageNo: 1,
  RowCountPerPage: 10,
  SortBy: "",
};

const podSearch = {
  PodCode: "",
  ActiveStatus: 2,
  PodName: "",
  SharedPod: 2,
  FacilityID: "",
  PageNo: 1,
  RowCountPerPage: 10,
  SortBy: "",
};

// create slice
const name = "pod";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports
export const PODAction = { ...slice.actions, ...extraActions };
export const PODReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    PODData: podSearch,
    initiallogHistoryData: initiallogHistoryData,
    getPODList: [],
    getPODFullData: [],
    managePODdata: initialPODData,
    specificPODdata: [],
    GetFacilityInfoData: [],
    InsertResponse: [],
    getPODKioskList: [],
    getSpecPodKiosk: [],
    logHistoryData: [],
    logHistoryFullData: [],
    logHistoryLastName: [],
    logHistorFirstName: [],
    PODKioskList: [],
    loading: false,
  };
}

function createReducers() {
  return {
    setPODListData,
    resetForm,
    clearResponse,
    searchPOD,
    clearAddPODData,
    resetSearchPOD,
    updateInitiallogHistoryData,
    resetInitiallogHistoryData,
  };

  function resetForm(state) {
    //state.PODData = podSearch;
    state.managePODdata = initialPODData;
    // state.logHistoryData = initiallogHistoryData;
  }
  function clearResponse(state, action) {
    state.InsertResponse = [];
    //state.managePODdata = initialPODData
  }
  function clearAddPODData(state, action) {
    state.managePODdata = [];
  }

  function setPODListData(state, action) {
    state.managePODdata = action.payload && action.payload;
  }

  function searchPOD(state, action) {
    state.PODData = action.payload && action.payload;
  }

  function resetSearchPOD(state) {
    state.PODData = podSearch;
  }

  function updateInitiallogHistoryData(state, action) {
    state.initiallogHistoryData = action.payload;
  }
  function resetInitiallogHistoryData(state) {
    state.initiallogHistoryData = initiallogHistoryData;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser/Pod`;
  const baseUrlOne = `${process.env.REACT_APP_API_URL}/ManagementUser/Inmate`;
  return {
    InsertPOD: InsertPOD(),
    UpdatePOD: UpdatePOD(),
    LoadPODList: LoadPODList(),
    GetFacilityAccessInfo: GetFacilityAccessInfo(),
    GetPODInfo: GetPODInfo(),
    LoadPODKioskList: LoadPODKioskList(),
    LoadInmateLoginLogHistory: LoadInmateLoginLogHistory(),

    GetPODKioskList: GetPODKioskList(),
  };

  function LoadPODList() {
    return createAsyncThunk(
      `${name}/LoadPODList`,
      async (params) =>
        await fetchWrapper.post(`${baseUrl}/LoadPODList`, params)
    );
  }
  function GetFacilityAccessInfo() {
    return createAsyncThunk(
      `${name}/GetFacilityAccessInfo`,
      async (facilityID) =>
        await fetchWrapper.post(
          `${baseUrl}/GetFacilityAccessInfo?facilityID=${facilityID}`
        )
    );
  }

  function InsertPOD() {
    return createAsyncThunk(
      `${name}/InsertPOD`,
      async (PODInsertData) =>
        await fetchWrapper.post(`${baseUrl}/InsertPOD`, PODInsertData)
    );
  }

  function UpdatePOD() {
    return createAsyncThunk(
      `${name}/UpdatePOD`,
      async (PODUpdateData) =>
        await fetchWrapper.post(`${baseUrl}/UpdatePOD`, PODUpdateData)
    );
  }

  function GetPODInfo() {
    return createAsyncThunk(
      `${name}/GetPODInfo`,
      async (Id) => await fetchWrapper.post(`${baseUrl}/GetPODInfo?PodID=${Id}`)
    );
  }

  function LoadPODKioskList() {
    return createAsyncThunk(
      `${name}/LoadPODKioskList`,
      async ({ PodID, facilityID }) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadPODKioskList?PodID=${PodID}&facilityID=${facilityID}`
        )
    );
  }

  function GetPODKioskList() {
    return createAsyncThunk(
      `${name}/GetPODKioskList`,
      async ({ PodID, facilityID }) =>
        await fetchWrapper.post(
          `${baseUrl}/GetPODKioskList?PodID=${PodID}&facilityID=${facilityID}`
        )
    );
  }

  function LoadInmateLoginLogHistory() {
    return createAsyncThunk(
      `${name}/LoadInmateLoginLogHistory`,
      async (LoginLogData) =>
        await fetchWrapper.post(
          `${baseUrlOne}/LoadInmateLoginLogHistory`,
          LoginLogData
        )
    );
  }
}

function createExtraReducers(builder) {
  builder
    //Load the POD List
    .addCase(extraActions.LoadPODList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.LoadPODList.fulfilled, (state, action) => {
      const params = action.meta.arg;
      if (params?.exportExcel) {
        state.getPODFullData = action?.payload;
      } else {
        state.getPODList = action.payload;
      }
      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.LoadPODList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })

    //GetFacilityAccessInfo
    .addCase(extraActions.GetFacilityAccessInfo.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetFacilityAccessInfo.fulfilled, (state, action) => {
      state.GetFacilityInfoData = action.payload;
      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.GetFacilityAccessInfo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })

    //Insert POD

    .addCase(extraActions.InsertPOD.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.InsertPOD.fulfilled, (state, action) => {
      state.InsertResponse = action.payload;
      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.InsertPOD.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to add POD";
    })

    //UPDATE POD

    .addCase(extraActions.UpdatePOD.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.UpdatePOD.fulfilled, (state, action) => {
      state.InsertResponse = action.payload;
      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.UpdatePOD.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to add POD";
    })

    //Get Specific POD Info
    .addCase(extraActions.GetPODInfo.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetPODInfo.fulfilled, (state, action) => {
      state.managePODdata = action.payload;
      state.specificPODdata = action.payload;
      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.GetPODInfo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })

    //Load POD Kiosk List
    .addCase(extraActions.LoadPODKioskList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.LoadPODKioskList.fulfilled, (state, action) => {
      state.getPODKioskList = action?.payload;
      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.LoadPODKioskList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })

    //Get POD Kiosk List
    .addCase(extraActions.GetPODKioskList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetPODKioskList.fulfilled, (state, action) => {
      state.getSpecPodKiosk = action?.payload;
      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.GetPODKioskList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })

    //Load Inmate Login Log History

    .addCase(extraActions.LoadInmateLoginLogHistory.pending, (state,action) => {
      state.loading = true;
      state.error = null;
      const params = action.meta.arg;
      if (params?.exportExcel) {
        state.logHistoryFullData = [];
      } else {
        state.logHistoryData = [];
      }
    })
    .addCase(
      extraActions.LoadInmateLoginLogHistory.fulfilled,
      (state, action) => {
        const params = action.meta.arg;
        if (params?.exportExcel) {
          state.logHistoryFullData = action?.payload;
        } else {
          state.logHistoryData = action.payload;
        }
        state.loading = false;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadInmateLoginLogHistory.rejected,
      (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to add Load Inmate Login Log History";
      }
    );
}
